import React from 'react';
export function SalesLetter() {
  return <section className="py-8 md:py-14 bg-cream" data-id="element-248">
      <div className="max-w-letter mx-auto px-4" data-id="element-249">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-center text-dark mb-5 md:mb-8" data-id="element-250">
          THE REAL PROBLEM
          <br data-id="element-251" />
          <span className="text-primary" data-id="element-252">(AND WHY IT'S NOT YOUR FAULT)</span>
        </h2>

        <div className="prose prose-lg max-w-none text-dark leading-relaxed space-y-3 md:space-y-5" data-id="element-253">
          <p className="text-xl" data-id="element-254">
            Your great-grandmother didn't need a pharmacy on every corner.
          </p>

          <p data-id="element-255">
            She had a garden. A kitchen. And knowledge — passed down from
            generation to generation — that told her exactly what to do when
            someone got sick.
          </p>

          <p className="text-xl font-medium text-primary" data-id="element-256">
            That knowledge still exists.
          </p>

          <p data-id="element-257">
            But somewhere between the 1950s and today, Big Pharma built a{' '}
            <span className="bg-gold-light px-2 py-1 rounded font-bold" data-id="element-258">
              $500 billion industry
            </span>{' '}
            on one simple idea: <em data-id="element-259">keep you dependent.</em>
          </p>

          <p data-id="element-260">
            They didn't discover better medicine. They patented what couldn't be
            patented before, funded the studies that buried natural
            alternatives, and made sure you'd never feel confident enough to
            handle your own family's health without them.
          </p>

          <p data-id="element-261">
            The result? The average American family now spends over{' '}
            <span className="bg-pain/10 px-2 py-1 rounded font-bold text-pain" data-id="element-262">
              $1,200 a year
            </span>{' '}
            on over-the-counter medications — products loaded with synthetic
            chemicals, artificial dyes, and compounds your liver has to fight to
            process.
          </p>

          <p className="text-lg" data-id="element-263">
            And the worst part?{' '}
            <strong data-id="element-264">
              Most of them just treat the symptom. Never the root cause.
            </strong>
          </p>

          <div className="bg-primary/5 border-l-4 border-primary p-4 md:p-6 rounded-r-lg my-4 md:my-6" data-id="element-265">
            <p className="text-xl font-heading font-bold text-primary italic mb-0" data-id="element-266">
              "You were never taught this knowledge. But you can have it today."
            </p>
          </div>
        </div>
      </div>
    </section>;
}